
export {IconAccessibility,
IconAddComment,
IconAlignBottom,
IconAlignCenter,
IconAlignJustify,
IconAlignLeft,
IconAlignMiddle,
IconAlignRight,
IconAlignTop,
IconArrowDown,
IconArrowUp,
IconBold,
IconBookmark,
IconBookmarkInline,
IconBookmarkMedium,
IconBookmarkSmall,
IconBrowseFiles,
IconBulletedList,
IconCancel,
IconCaption,
IconCaseChange,
IconCheck,
IconChevronDown,
IconChevronUp,
IconCkboxImageEdit,
IconCode,
IconCodeBlock,
IconCog,
IconColorPalette,
IconColorTileCheck,
IconCommentsArchive,
IconContentLock,
IconContentUnlock,
IconCopy,
IconDragHandle,
IconDragIndicator,
IconDropbox,
IconDropdownArrow,
IconEditComment,
IconEmoji,
IconEraser,
IconError,
IconExportPdf,
IconExportWord,
IconFacebook,
IconFindReplace,
IconFontBackground,
IconFontColor,
IconFontFamily,
IconFontSize,
IconFullscreenEnter,
IconFullscreenLeave,
IconGoogleDrive,
IconGooglePhotos,
IconHeading1,
IconHeading2,
IconHeading3,
IconHeading4,
IconHeading5,
IconHeading6,
IconHistory,
IconHorizontalLine,
IconHtml,
IconImage,
IconImageAssetManager,
IconImageUpload,
IconImageUrl,
IconImportExport,
IconImportWord,
IconIndent,
IconInsertMergeField,
IconItalic,
IconLegalStyleList,
IconLineHeight,
IconLink,
IconListStyleCircle,
IconListStyleDecimal,
IconListStyleDecimalLeadingZero,
IconListStyleDisc,
IconListStyleLowerLatin,
IconListStyleLowerRoman,
IconListStyleSquare,
IconListStyleUpperLatin,
IconListStyleUpperRoman,
IconLocal,
IconLoupe,
IconLowVision,
IconMagicWand,
IconMarker,
IconMedia,
IconMediaPlaceholder,
IconMultiLevelList,
IconNextArrow,
IconNotification,
IconNumberedList,
IconObjectCenter,
IconObjectFullWidth,
IconObjectInline,
IconObjectInlineLeft,
IconObjectInlineRight,
IconObjectLeft,
IconObjectRight,
IconObjectSizeCustom,
IconObjectSizeFull,
IconObjectSizeLarge,
IconObjectSizeMedium,
IconObjectSizeSmall,
IconOneDrive,
IconOutdent,
IconPageBreak,
IconPaginationExample,
IconPaintRoller,
IconPaintRollerCursorDefault,
IconPaintRollerCursorText,
IconParagraph,
IconPen,
IconPencil,
IconPilcrow,
IconPlay,
IconPlus,
IconPreviewMergeFields,
IconPreviousArrow,
IconPrint,
IconProjectLogo,
IconQuote,
IconRedo,
IconRemove,
IconRemoveComment,
IconRemoveFormat,
IconReturnArrow,
IconRevisionHistory,
IconRobotPencil,
IconSelectAll,
IconSettings,
IconShowBlocks,
IconSource,
IconSpecialCharacters,
IconStrikethrough,
IconSubmit,
IconSubscript,
IconSuperscript,
IconTable,
IconTableCellProperties,
IconTableColumn,
IconTableLayout,
IconTableMergeCell,
IconTableOfContents,
IconTableProperties,
IconTableRow,
IconTemplate,
IconTemplateGeneric,
IconText,
IconTextAlternative,
IconThreeVerticalDots,
IconTodoList,
IconTrackChanges,
IconTrackChangesAccept,
IconTrackChangesDiscard,
IconUnderline,
IconUndo,
IconUnlink,
IconUploadcareImageEdit,
IconUploadcareImageUpload,
IconUploadcareLink,
IconUser,
IconWarning} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-icons$dist$index.js.js';
